import { KumpulkanDokumen } from 'app/KinerjaPage/pages/PelaksanaanV2/PenilaianKinerja/KumpulkanDokumen'
import KinerjaLayout from 'app/KinerjaPage/components/KinerjaDemoLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { KinerjaApp } from 'types/kinerja-layout'
import type { PageProps } from 'app/KinerjaShared/components/KinerjaLayout'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const npsn = 'demo'

    if (
      !toggle?.['kinerja-enabled'] ||
      !toggle?.['kinerja-pelaksanaan-enabled'] ||
      !toggle?.['kinerja-penilaian-demo-mode-enabled']
    ) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {
        npsn,
      },
    }
  },
})

const Page: KinerjaApp = ({ npsn }: PageProps & { npsn: string }) => {
  return <KumpulkanDokumen npsn={npsn} />
}

export default Page

Page.Layout = KinerjaLayout

Page.layoutOpts = {}
